import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { ReactComponent as DeleteIcon } from "src/assets/icons/delete.svg";
import { isArabic } from "src/utils/helpers";
interface ConsolidatedInvoiceListProps {
  showPayButton: boolean;
  removeInvoiceHandler?: (invoiceId: string) => void;
}

const ConsolidatedInvoiceList: React.FC<ConsolidatedInvoiceListProps> = ({
  showPayButton,
  removeInvoiceHandler,
}) => {
  const { t } = useTranslation(["common", "invoice", "registration"]);
  const { totalAmount, invoiceList, totalAmountWithoutTax, totalTax } =
    useSelector(
      (state: any) => state.invoices.consolidatedInvoiceDetailsPopupData
    );

  const invoiceTotals = [
    {
      label: t("invoiceDetails.totalAmountWithoutTax"),
      value: totalAmountWithoutTax,
    },
    {
      label: t("invoiceDetails.totalTax"),
      value: totalTax,
    },
    {
      label: t("totalAmount"),
      value: totalAmount,
    },
  ];

  return (
    <section className="invoice-body invoice-amount mt-1" style={{ direction: isArabic() ? "rtl" : "ltr" }}>
      <div className="invoice-body__sub-title py-1 px-2 d-flex" style={{ direction: isArabic() ? "rtl" : "ltr" }}>
        <span className="w-25 cell-header">
          {t("invoiceDetails.invoiceNumber")}
        </span>
        <span className="w-25 cell-header">{t("contractNo")}</span>
        <span className="w-25 cell-header">{t("assignedBuilding")}</span>
        <span className="w-15 cell-header">
          {t("invoiceDetails.amountAED")}
        </span>
        {showPayButton && (
          <span className="w-5 cell-header">{t("action")}</span>
        )}
      </div>
      <div className="invoice-header__details__info d-flex flex-column">
        {invoiceList?.map((invoice: any) => (
          <div key={invoice.invoiceNumber}>
            <div className="invoice-header__details__info__row d-flex justify-content-between px-2">
              <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between w-25 pt-2">
                <span>{invoice.invoiceNumber}</span>
              </div>
              <VerticalDivider />
              <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center w-25 pt-2">
                <span>{invoice.contractNumber}</span>
              </div>
              <VerticalDivider />
              <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center w-25 pt-2">
                <span>{invoice.buildingName}</span>
              </div>
              <VerticalDivider />
              <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center w-25 pt-2">
                <span>{invoice.totalAmount}</span>
              </div>
              {showPayButton && (
                <>
                  <VerticalDivider />
                  <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center w-5 pt-2">
                    <DeleteIcon
                      className="cursor-pointer delete-icon"
                      onClick={() =>
                        removeInvoiceHandler &&
                        removeInvoiceHandler(invoice.invoiceId)
                      }
                    />
                  </div>
                </>
              )}
            </div>
            <HorizontalDivider />
          </div>
        ))}

        {invoiceTotals.map((item, index) => (
          <React.Fragment key={index}>
            <div
              className={`invoice-header__details__info__row total d-flex w-100  ${
                index === invoiceTotals.length - 1 ? "total-with-tax" : ""
              }`}
            >
              <div
                className={`invoice-header__details__info__row__item total-label d-flex align-items-center justify-content-end  ${
                  showPayButton ? "with-action" : "without-action"
                }`}
              >
                <h6 className="w-30 text-start px-2">{item.label}</h6>
              </div>
              <VerticalDivider />
              <div
                className={`invoice-header__details__info__row__item d-flex align-items-start justify-content-center w-25`}
              >
                <span>{item.value}</span>
              </div>
            </div>
            <HorizontalDivider />
          </React.Fragment>
        ))}
      </div>
      <HorizontalDivider />
    </section>
  );
};

export default ConsolidatedInvoiceList;
